// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1YbLf","savePackageButton":"ClientWallet_savePackageButton__2ehL4"};